import * as types from '../mutation-types'

const dict = {
  state: {
    country: [],
    gender: [],
    title: [],
    editorialBoard: [],
    guestEditor: [],
    managementTeam: [],

    attachmentType: [],
    degree: [],
    highestDegree: [],
    manuscriptType: [],
    manuscriptTypeList: [],
    reviewFrequency: [],
    reviewType: [],
    reviewRefuse: [],
    indexedDatabase: [],
    sectionEditor: [],
    academicRank: []
  },

  getters: {
    getCountry: state => state.country,
    getGender: state => state.gender,
    getTitle: state => state.title,
    getEditorialBoard: state => state.editorialBoard,
    getGuestEditor: state => state.guestEditor,
    getManagementTeam: state => state.managementTeam,

    getAttachmentType: state => state.attachmentType,
    getDegree: state => state.degree,
    getHighestDegree: state => state.highestDegree,
    getManuscriptType: state => state.manuscriptType,
    getManuscriptTypeList: state => state.manuscriptTypeList,
    getReviewFrequency: state => state.reviewFrequency,
    getReviewType: state => state.reviewType,
    getReviewRefuse: state => state.reviewRefuse,
    getIndexedDatabase: state => state.indexedDatabase,
    getSectionEditor: state => state.sectionEditor,
    getAcademicRank: state => state.academicRank
  },

  actions: {
    updateCountry({ commit }, info) {
      commit(types.UPDATE_COUNTRY, info)
    },
    updateGender({ commit }, info) {
      commit(types.UPDATE_GENDER, info)
    },
    updateTitle({ commit }, info) {
      commit(types.UPDATE_TITLE, info)
    },
    updateEditorialBoard({ commit }, info) {
      commit(types.UPDATE_EDITORIAL_BOARD, info)
    },
    updateGuestEditor({ commit }, info) {
      commit(types.UPDATE_GUEST_EDITOR, info)
    },
    updateManagementTeam({ commit }, info) {
      commit(types.UPDATE_MANAGEMENT_TEAM, info)
    },

    updateAttachmentType({ commit }, info) {
      commit(types.UPDATE_ATTACHMENT_TYPE, info)
    },
    updateDegree({ commit }, info) {
      commit(types.UPDATE_DEGREE, info)
    },
    updateHighestDegree({ commit }, info) {
      commit(types.UPDATE_HIGHEST_DEGREE, info)
    },
    updateManuscriptType({ commit }, info) {
      commit(types.UPDATE_MANUSCRIPT_TYPE, info)
    },
    updateManuscriptTypeList({ commit }, info) {
      commit(types.UPDATE_MANUSCRIPT_TYPE, info)
    },
    updateReviewFrequency({ commit }, info) {
      commit(types.UPDATE_REVIEW_FREQUENCY, info)
    },
    updateReviewType({ commit }, info) {
      commit(types.UPDATE_REVIEW_TYPE, info)
    },
    updateReviewRefuse({ commit }, info) {
      commit(types.UPDATE_REVIEW_REFUSE, info)
    },
    updateIndexedDatabase({ commit }, info) {
      commit(types.UPDATE_INDEXED_DATABASE, info)
    },
    updateSectionEditor({ commit }, info) {
      commit(types.UPDATE_SECTION_EDITOR, info)
    },
    updateAcademicRank({ commit }, info) {
      commit(types.UPDATE_ACADEMIC_RANK, info)
    }
  },

  mutations: {
    [types.UPDATE_COUNTRY](state, info) {
      state.country = info
    },
    [types.UPDATE_GENDER](state, info) {
      state.gender = info
    },
    [types.UPDATE_TITLE](state, info) {
      state.title = info
    },
    [types.UPDATE_EDITORIAL_BOARD](state, info) {
      state.editorialBoard = info
    },
    [types.UPDATE_GUEST_EDITOR](state, info) {
      state.guestEditor = info
    },
    [types.UPDATE_MANAGEMENT_TEAM](state, info) {
      state.managementTeam = info
    },

    [types.UPDATE_ATTACHMENT_TYPE](state, info) {
      state.attachmentType = info
    },
    [types.UPDATE_DEGREE](state, info) {
      state.degree = info
    },
    [types.UPDATE_HIGHEST_DEGREE](state, info) {
      state.highestDegree = info
    },
    [types.UPDATE_MANUSCRIPT_TYPE](state, info) {
      state.manuscriptType = info
    },
    [types.UPDATE_MANUSCRIPT_TYPE_LIST](state, info) {
      state.manuscriptTypeList = info
    },
    [types.UPDATE_REVIEW_FREQUENCY](state, info) {
      state.reviewFrequency = info
    },
    [types.UPDATE_REVIEW_TYPE](state, info) {
      state.reviewType = info
    },
    [types.UPDATE_REVIEW_REFUSE](state, info) {
      state.reviewRefuse = info
    },
    [types.UPDATE_INDEXED_DATABASE](state, info) {
      state.indexedDatabase = info
    },
    [types.UPDATE_SECTION_EDITOR](state, info) {
      state.sectionEditor = info
    },
    [types.UPDATE_ACADEMIC_RANK](state, info) {
      state.academicRank = info
    }
  }
}

export default dict
